/**
 * routers
 * 更多关于Router的使用，请参考以下教程
 * https://github.com/ReactTraining/react-router/blob/master/docs/guides/RouteConfiguration.md
 */

import Index from "./Index";

const router = {
  path: "thread",
  breadcrumbName: "线索管理",
  childRoutes: [
    {
      path: "list",
      breadcrumbName: "线索列表",
      component: Index,
    },
  ],
};

export default router;



// WEBPACK FOOTER //
// ./src/components/crm/thread/router.js